import { render } from "./DropboxTable.vue?vue&type=template&id=8a5483ea&scoped=true"
import script from "./DropboxTable.vue?vue&type=script&lang=js"
export * from "./DropboxTable.vue?vue&type=script&lang=js"

import "./DropboxTable.vue?vue&type=style&index=0&id=8a5483ea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5483ea"]])

export default __exports__